import { PROPERTY_TYPE_MAP } from '@/entities/map'
import { PropertyType } from '@/entities/room'

import { RoomShareUserType } from '../model/room-share-user-type'

const env = process.env.NEXT_PUBLIC_ENVIRONMENT
const category = env === 'live' ? 'live_room_shared' : 'test_room_shared'
const place = env === 'local' || !env ? 'test' : env

type RoomFields = {
  rid: number
  roomName: string
  propertyType: PropertyType
  usingFee: number
  mgmtFee: number
  state: string
  province: string
}

export const buildRoomShareEventObject = (
  room: RoomFields,
  userType: RoomShareUserType,
) => ({
  event: category,
  params: {
    action: `${room.state} ${room.province}`,
    label: userType,
    semanticAttributes: {
      currency: 'KRW',
      products: [
        {
          productID: room.rid,
          name: room.roomName,
          categoryName: PROPERTY_TYPE_MAP[room.propertyType],
          price: room.usingFee + room.mgmtFee,
        },
      ],
      place,
    },
  },
})

export type RoomShareEventPayload = ReturnType<typeof buildRoomShareEventObject>
